// extracted by mini-css-extract-plugin
export var divider = "_redotech-arbiter-lib-divider-divider-divider";
export var dividerText = "_redotech-arbiter-lib-divider-divider-divider-text";
export var dividerVertical = "_redotech-arbiter-lib-divider-divider-divider-vertical";